var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 15.5H2.16667C1.25 15.5 0.5 14.75 0.5 13.8333V2.16667C0.5 1.25 1.25 0.5 2.16667 0.5H7.16667V15.5ZM8.83333 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V8H8.83333V15.5ZM15.5 6.33333V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5H8.83333V6.33333H15.5Z",
    fill: "#D58DE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/request_icon.5e0398685fbca0880897881e0f2105de.svg";
export { ForwardRef as ReactComponent };